import { createSlice } from '@reduxjs/toolkit';

const saveDataToLocalStorage = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
};

const getDataFromLocalStorage = (key) => {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : undefined;
};

const dataSlice = createSlice({
    name: 'Website/data',
    initialState: {
        PaymentSelected: getDataFromLocalStorage('PaymentSelected') || [],
        PaymentResponse: getDataFromLocalStorage('PaymentResponse') || null,
        LlojiPagesesKesco: [],
        ManualetSelectedInsitucioni: null,
        ManualetLlojiPagesesLoad: false,
        LlojiPagesesManualet: [],
        Institucionet: [],
        PaymentSuccess: null,
        AlertMessage: null,
        EsimPackages: [],
        EsimPackageSelected: [],
        EsimPackageSelectedBox: null,
        EsimCountriesList: [],
        EsimRefills: [],
        EsimRefillSelectedBox: null,
        EsimRefillSelected: null,
    },
    reducers: {
        SelectPayment: (state, action) => {
            state.PaymentSelected = action.payload;
            saveDataToLocalStorage('PaymentSelected', state.PaymentSelected);
        },
        setPaymentResponse: (state, action) => {
            state.PaymentResponse = action.payload;
            saveDataToLocalStorage('PaymentResponse', state.PaymentResponse);
        },
        // setLlojiPagesesKesco: (state, action) => {
        //     state.LlojiPagesesKesco = action.payload;
        // },
        setManualetSelectedInsitucioni: (state, action) => {
            state.ManualetSelectedInsitucioni = action.payload;
        },
        setManualetLlojiPagesesLoad: (state, action) => {
            state.ManualetLlojiPagesesLoad = action.payload;
        },
        setLlojiPagesesManualet: (state, action) => {
            state.LlojiPagesesManualet = action.payload;
        },
        setInstitucionet: (state, action) => {
            state.Institucionet = action.payload;
        },
        setPaymentSuccess: (state, action) => {
            state.PaymentSuccess = action.payload;
        },
        setAlertMessage: (state, action) => {
            state.AlertMessage = action.payload;
        },
        setEsimPackages: (state, action) => {
            state.EsimPackages = action.payload;
        },
        setEsimPackageSelected: (state, action) => {
            state.EsimPackageSelected = action.payload;
        },
        setEsimPackageSelectedBox: (state, action) => {
            state.EsimPackageSelectedBox = action.payload;
        },
        setEsimCountriesList: (state, action) => {
            state.EsimCountriesList = action.payload;
        },
        setEsimRefills: (state, action) => {
            state.EsimRefills = action.payload;
        },
        setEsimRefillSelectedBox: (state, action) => {
            state.EsimRefillSelectedBox = action.payload;
        },
        setEsimRefillSelected: (state, action) => {
            state.EsimRefillSelected = action.payload;
        },
    },
});

export const {
    SelectPayment,
    setPaymentResponse,
    // setLlojiPagesesKesco,
    setLlojiPagesesManualet,
    setManualetSelectedInsitucioni,
    setManualetLlojiPagesesLoad,
    setInstitucionet,
    setPaymentSuccess,
    setAlertMessage,
    setEsimPackages,
    setEsimPackageSelected,
    setEsimCountriesList,
    setEsimRefills,
    setEsimRefillSelectedBox,
    setEsimRefillSelected,
    setEsimPackageSelectedBox,
} = dataSlice.actions;

export default dataSlice.reducer;
